"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function parseType(mainType) {
  var type = null;
  var bytes = null;

  if (mainType.startsWith('bytes')) {
    bytes = parseInt(mainType.replace('bytes', ''), 10);
    type = 'bytes';
  } else if (mainType.startsWith('uint')) {
    bytes = parseInt(mainType.replace('uint', ''), 10) / 8;
    type = 'uint';
  }

  return {
    type: type,
    bytes: bytes
  };
}

exports.parseType = parseType;